import { Appointment, StartAppointmentDto } from "@myapp/contract";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { appointmentKeys } from "../appointment.keys";
import { appointmentApi } from "../service";
import { auditLogKeys } from "../../../audit-log";

export function useStartAppointment() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ id, dto, workOrderId }: { id: string; dto: StartAppointmentDto; workOrderId?: string }) => {
      const { data } = await appointmentApi.start(id, dto);
      return { appointment: data as Appointment, workOrderId };
    },
    onSettled: (_data, _err, vars) => {
      queryClient.invalidateQueries({ queryKey: appointmentKeys.all });
      if (vars?.workOrderId) {
        queryClient.invalidateQueries({ queryKey: auditLogKeys.byWorkOrder(vars.workOrderId) });
      }
    },
  });
}
